function Footer({ nav_data }) {
  var year = new Date().getFullYear();
  var footer_menus =
    nav_data &&
    nav_data.primary
      .filter(function (e) {
        return !!e.submenu;
      })
      .slice(0, 5);
  return (
    <footer>
      <div className="content">
        <nav className="footer-menu">
          <label htmlFor="show-menu" className="menu-toggle">
            Menu
          </label>
          <label htmlFor="show-menu" className="menu-toggle close">
            Close
          </label>
          <ul className="menu">
            {footer_menus &&
              footer_menus.map((item) => {
                return (
                  <li key={item.href + "-footer"}>
                    <a href={item.href}>{item.title}</a>
                    <ul className="submenu">
                      {item.submenu.map((item) => (
                        <li key={item.href}>
                          <a href={item.href}>{item.title}</a>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              })}
          </ul>
        </nav>
        <div className="connect">
          <section className="contact">
            <img
              className="logo"
              src={
                window.cms_base_url +
                "/++theme++plonetheme.wta/images/wta-logo.png"
              }
              width="318"
              height="380"
              alt="Washington Trails Associations"
            />
            <h2>Contact Us</h2>
            <address>
              <p>
                Washington Trails Association
                <br />
                705 2nd Ave, Suite 300
                <br />
                Seattle, WA 98104
              </p>
              <p>(206) 625-1367</p>
            </address>
          </section>
          <section className="newsletter">
            <h2>
              <svg className="envelope">
                <use xlinkHref="#envelope"></use>
              </svg>
              Get Trail News
            </h2>
            <p>
              Subscribe to our free email newsletter for hiking events, news,
              gear reviews and more.
            </p>
            <form>
              <input
                type="text"
                placeholder="Email address"
                name="email_name"
              />
              <button>Sign Up</button>
            </form>
          </section>
          <nav className="social-nav">
            <ul className="menu">
              <li>
                <a href="http://facebook.com/washingtontrails">
                  <svg className="facebook">
                    <use xlinkHref="#facebook"></use>
                  </svg>
                </a>
              </li>
              <li>
                <a href="http://twitter.com/WTA_hikers">
                  <svg className="twitter">
                    <use xlinkHref="#twitter"></use>
                  </svg>
                </a>
              </li>
              <li>
                <a href="http://pinterest.com/WTAhikers/">
                  <svg className="pinterest">
                    <use xlinkHref="#pinterest"></use>
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/washingtontrails/">
                  <svg className="instagram">
                    <use xlinkHref="#instagram"></use>
                  </svg>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <p className="tagline">
          Empowering hikers to build a world where trails connect people and
          places
        </p>
        <nav className="bottom-menu">
          <ul className="menu">
            <li>@ {year} Washington Trails Association</li>
            <li>
              <a href={window.cms_base_url + "our-work/about/terms-of-service"}>
                Terms of Service
              </a>
            </li>
            <li>
              <a href={window.cms_base_url + "our-work/about/privacy"}>
                Privacy Policy
              </a>
            </li>
          </ul>
        </nav>
        <p className="credit">
          <a href="http://www.nealmaher.com">
            Design:{" "}
            <img
              src={
                window.cms_base_url +
                "/++theme++plonetheme.wta/images/svg/neal-logo.svg"
              }
              alt="Neal Maher, design for social change"
              width="100"
              height="17"
            />
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
